export default __webpack_public_path__ + "2cee75c636f6b881e332c07e5aff2773.png";